import { UserPermission } from '@/modules/permission/enum';
export const debriefRoutes = [
    {
        path: '',
        name: 'Debriefs',
        exact: true,
        component: () => import('../views/DebriefIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Debriefs' }],
            permissions: [UserPermission.READ_DEBRIEF],
        },
    },
    {
        path: 'form',
        name: 'DebriefForm',
        exact: true,
        props: route => ({ debriefId: route.query.debriefId }),
        component: () => import('../views/DebriefForm.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'All Debriefs', routerLink: { name: 'Debriefs' } }, label: 'Debrief Form' }],
            permissions: [UserPermission.WRITE_DEBRIEF],
        },
    },
    {
        path: 'createUpdate',
        name: 'DebriefCreateUpdate',
        exact: true,
        props: route => ({ debriefId: route.query.debriefId }),
        component: () => import('../views/DebriefCreateUpdate.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'All Debriefs', routerLink: { name: 'Debriefs' } }, label: 'Debrief Form' }],
            permissions: [UserPermission.WRITE_DEBRIEF],
        },
    },
    {
        path: 'add',
        name: 'DebriefCreateFast',
        exact: true,
        component: () => import('../views/DebriefFast.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'All Debriefs', routerLink: { name: 'Debriefs' } }, label: 'Debrief Form' }],
            permissions: [UserPermission.WRITE_DEBRIEF],
        },
    },
    {
        path: ':id',
        name: 'DebriefDetails',
        props: true,
        exact: true,
        component: () => import('../views/DebriefDetails.vue'),
        meta: {
            breadcrumb: [{ parent: { label: 'All Debriefs', routerLink: { name: 'Debriefs' } }, label: 'Debrief Details' }],
            permissions: [UserPermission.READ_DEBRIEF],
        },
    },
];
